import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const StyledTypography = styled(Typography)`
  color: #616060de;
  padding-left: 40px;
  padding-top: 15px;
`;
